<template>
  <div class="buyerShop">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10" class="border-right">
          <el-form-item :label="$t('crm.vendorName')" prop="vendorName">
            <el-input v-model="ruleForm.vendorName" :readonly="isAudit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorType')" prop="vendorType">
            <el-select v-model="ruleForm.vendorType" @change="onChangeVendorType" :disabled="isAudit">
              <el-option v-for="item in vendorTypeList" :label="item.desc" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorType === 5" :label="$t('crm.personalSellerIMID')" prop="sellerUserId">
            <el-input v-model="ruleForm.sellerUserId" :readonly="isAudit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.country')" prop="addressCountryId">
            <el-select v-model="ruleForm.addressCountryId" @change="changeAddressCountryId" filterable :placeholder="$t('common.country')" :disabled="isAudit">
              <el-option v-for="item in countryList" :label="item.name" :value="item.addressCountryId" :key="item.addressCountryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorCurrency')" prop="originalPriceUnit">
            <el-select v-model="ruleForm.originalPriceUnit" filterable :placeholder="$t('crm.currency')" :disabled="isAudit">
              <el-option v-for="item in unitList" :label="item.fromCountry" :value="item.fromCountry" :key="item.productExchangeRateId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.retailPriceIncludesTax')" prop="retailPriceTax">
            <el-radio-group v-model="ruleForm.retailPriceTax" :disabled="isAudit">
              <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('crm.pricingConnectivityMethod')" prop="vendorSupplyPriceMethod">
            <el-radio-group v-model="ruleForm.vendorSupplyPriceMethod" :disabled="isAudit">
              <el-radio v-for="item in supplyPriceMethod" :label="item.dictCode" :key="item.dictCode">{{item.dictValue}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorSupplyPriceMethod === '1'" :label="$t('crm.supplyPriceIncludesTax')" prop="boutiquePriceTax">
            <el-radio-group v-model="ruleForm.boutiquePriceTax" :disabled="isAudit">
              <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorSupplyPriceMethod === '2'" :label="$t('crm.provideHangingPrice')" prop="provideRetailPrice">
            <el-radio-group v-model="ruleForm.provideRetailPrice" :disabled="isAudit">
              <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
              <el-radio :label="2">{{ $t('common.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('crm.preSaleAvailablity')" prop="isPreSale">
            <el-radio-group v-model="ruleForm.isPreSale" :disabled="isAudit || isPreSaleDisabled">
              <el-radio :label="1">{{ $t('crm.support') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.notSupport') }}</el-radio>
              <el-radio :label="3">{{ $t('crm.rollingPreSale') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('crm.contractOrSLASigned')" prop="isSignSla">
            <el-radio-group v-model="ruleForm.isSignSla" :disabled="isAudit">
              <el-radio :label="2">{{ $t('common.yes') }}</el-radio>
              <el-radio :label="1">{{ $t('common.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="货单类型" prop="wholesaleType" v-if="ruleForm.vendorType == 7">
            <el-radio-group v-model="ruleForm.wholesaleType" :disabled="isAudit" @change="onChangeWholesaleType">
              <el-radio :label="1">现货货单</el-radio>
              <el-radio :label="4">品牌补货</el-radio>
              <el-radio :label="5">期货预售</el-radio>

            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.isSignSla === 2" :label="$t('crm.contractTime')" prop="signSlaTimeStamp">
            <el-date-picker
              v-model="ruleForm.signSlaTimeStamp"
              type="date"
              :editable="false"
              :clearable="false"
              value-format="timestamp"
              :disabled="isAudit"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10">
          <el-form-item :label="$t('crm.imRepresentative')" prop="boutiqueBdId">
            <el-select v-model="ruleForm.boutiqueBdId" @change="changeBoutiqueBdId" filterable :disabled="isAudit">
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.imAssistantRepresentative')" prop="boutiqueAssistantId">
            <el-select v-model="ruleForm.boutiqueAssistantId" @change="changeBoutiqueAssistantId" filterable :disabled="isAudit">
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorRegion')" prop="businessRegionId">
            <el-select v-model="ruleForm.businessRegionId" @change="onChangeBusinessRegion" :disabled="isAudit">
              <el-option v-for="item in businessRegionList" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('crm.parentCompanyName')}(${$t('crm.businessEntityName')})`" prop="groupName">
            <el-autocomplete v-model="ruleForm.groupName" value-key="groupName" :fetch-suggestions="querySearch" :disabled="isAudit"></el-autocomplete>
          </el-form-item>
          <!-- <el-form-item :label="$t('crm.ifIMCanGetTaxBack')" prop="drawback">
            <el-select v-model="ruleForm.drawback" :disabled="isAudit">
              <el-option :label="$t('common.yes')" :value="1"></el-option>
              <el-option :label="$t('common.no')" :value="0"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('crm.operationType')" prop="vendorOperationType">
            <el-select v-model="ruleForm.vendorOperationType" :disabled="isAudit">
              <el-option v-for="item in vendorOperationType" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <p class="group-title" v-if="ruleForm.vendorType === 3">{{ $t('crm.wholesaleV2Conf') }}</p>
          <el-form-item v-if="ruleForm.vendorType === 3" :label="$t('crm.wholesaleField1')" prop="wholesaleOneVendorId">
            <el-select v-model="ruleForm.wholesaleOneVendorId" filterable :disabled="isAudit">
              <el-option v-for="item in xiajiArr" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorType === 3" :label="$t('crm.wholesaleField2')" prop="marketplaceVendorId">
            <el-select v-model="ruleForm.marketplaceVendorId" filterable :disabled="isAudit">
              <el-option v-for="item in tongbuArr" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="mt20" v-if="!isAudit && !isShow">
      <span class="f14">{{ $t('crm.copyInvoiceFrom') }}</span>
      <el-select v-model="copyTargetVendorId" filterable clearable @change="onChangeCopyVendor" style="width: 200px;">
        <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
    </div>

    <el-tabs class="mt20" v-model="activeTab" type="card" @tab-click="handleClick">
      <el-tab-pane :label="$t('crm.billingInfo2')" name="billingInfo"></el-tab-pane>
      <el-tab-pane :label="$t('crm.payment')" name="payment"></el-tab-pane>
      <el-tab-pane :label="$t('common.stockLocation')" name="stockLocation"></el-tab-pane>
      <el-tab-pane :label="$t('crm.notifyEmailSettings')" name="notifyEmailSettings"></el-tab-pane>
      <el-tab-pane :label="$t('crm.workOrderAutoEmailSettings')" name="workOrderAutoEmailSettings"></el-tab-pane>
      <el-tab-pane :label="$t('crm.vendorOrderPushEmail')" name="vendorOrderPushEmail"></el-tab-pane>
      <el-tab-pane :label="$t('crm.logisticsRelated')" name="logisticsRelated"></el-tab-pane>
    </el-tabs>

    <el-row v-show="activeTab === 'billingInfo'">
      <el-col :xs="24" :sm="24" :md="20" :lg="18" :xl="16">
        <el-form class="searchForm" :model="invoiceDto" ref="invoiceDtoForm" label-position="top">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('crm.companyName')" prop="companyName">
                <el-input v-model="invoiceDto.companyName" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="16" :xl="16">
              <el-form-item :label="$t('crm.vatNumber')" prop="businessLicenseNumber">
                <el-input v-model="invoiceDto.businessLicenseNumber" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('crm.contactPerson')" prop="registeredPerson">
                <el-input v-model="invoiceDto.registeredPerson" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('crm.contactEmail')">
                <el-input v-model="invoiceDto.contactEmail" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('crm.contactPhoneNumber')">
                <el-row>
                  <el-col :span="6">
                    <el-input v-model="invoiceDto.areaCode" :readonly="isAudit"></el-input>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="invoiceDto.contactPhone" :readonly="isAudit"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('common.country')" prop="addressCountryId">
                <el-select v-model="invoiceDto.addressCountryId" @change="changeInvoiceAddressCountry" :placeholder="$t('common.country')" disabled>
                  <el-option v-for="item in countryList" :label="item.name" :value="item.addressCountryId" :key="item.addressCountryId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('common.city')">
                <el-select
                  v-model="invoiceDto.city"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod2"
                  :loading="cityLoading"
                  :disabled="isAudit">
                  <el-option v-for="item in cityList2" :key="item.cityName" :label="item.cityName" :value="item.cityName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t('common.postCode')">
                <el-input v-model="invoiceDto.postalCode" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item :label="$t('common.address')" prop="businessLicenseLocation">
                <el-input v-model="invoiceDto.businessLicenseLocation" :readonly="isAudit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <el-row v-show="activeTab === 'payment'">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="vendorPayment" :rules="vendorPaymentRules" ref="vendorPaymentForm" label-width="200px">
          <h2>{{ $t('crm.payment') }}</h2>
          <el-form-item :label="$t('crm.paymentMethod')" prop="paymentMethod">
            <el-select v-model="vendorPayment.paymentMethod" @change="changePaymentMethod" :disabled="isAudit">
              <el-option v-for="item in paymentMethodList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.depositAmount')" prop="depositAmount" :rules="[{
            required: vendorPayment.paymentMethod === 'crm_pre_payment',
            message: `${this.$t('common.plzInput')}${this.$t('crm.depositAmount')}`
          }]">
            <el-input v-model="vendorPayment.depositAmount" :readonly="isAudit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.paymentTiming')" prop="paymentTiming">
            <el-row>
              <el-col :span="vendorPayment.paymentTiming === 'crm_payment_others' ? 12 : 24">
                <el-select v-model="vendorPayment.paymentTiming" @change="changePaymentTiming" :disabled="isAudit">
                  <el-option v-for="item in paymentTimingList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
                </el-select>
              </el-col>
              <el-col :span="12" v-if="vendorPayment.paymentTiming === 'crm_payment_others'">
                <el-input v-model="vendorPayment.paymentTimingRemark" :placeholder="$t('crm.otherPaymentTiming')" :readonly="isAudit"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('crm.settlementCycle')" v-if="vendorPayment.paymentTiming === 'crm_payment_week'" prop="paymentTimingTime">
            <el-select v-model="vendorPayment.paymentTimingTime" :disabled="isAudit">
              <el-option v-for="(item, index) in 7" :key="item" :label="$t(`common.week${index}`)" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.paymentRemark')">
            <el-input v-model="vendorPayment.paymentMethodRemark" :readonly="isAudit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorSettlementCurrency')">
            <el-select v-model="vendorPayment.settleCurrency" clearable>
              <el-option v-for="item in unitList" :label="item.fromCountry" :value="item.fromCountry"
                          :key="item.productExchangeRateId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <h2 class="mt30" v-if="activeTab === 'payment'">{{ $t('crm.payeeInfo') }}</h2>
    <el-table v-if="activeTab === 'payment'"  :data="receivePaymentReqVos" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
      <el-table-column prop="payeeName" :label="$t('crm.payeeName')"></el-table-column>
      <el-table-column prop="bankOfName" :label="$t('crm.bankName')"></el-table-column>
      <el-table-column prop="bankAddress" :label="$t('crm.bankAddress')"></el-table-column>
      <el-table-column prop="bankAccountNo" :label="$t('crm.bankAccount')"></el-table-column>
      <el-table-column prop="swiftCode" :label="$t('crm.swiftCode')"></el-table-column>
      <el-table-column prop="iban" :label="$t('crm.iban')"></el-table-column>
      <el-table-column prop="payType" :label="$t('crm.payMethod')">
        <template slot-scope="scope">
            {{scope.row.payType==1?$t('crm.overseaPayment'):$t('crm.domesticPayment') }}
        </template>
      </el-table-column>
      <el-table-column prop="idNo" :label="$t('crm.idNumber')"></el-table-column>
      <el-table-column prop="phoneNum" :label="$t('crm.phoneNumber')"></el-table-column>
      <el-table-column prop="defaultOption" :label="$t('crm.defaultOption')">
        <template slot-scope="scope">{{scope.row.defaultOption === 1 ? $t('common.yes') : scope.row.defaultOption === 0 ? $t('common.no') : "" }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.action')" v-if="!isAudit">
        <template slot-scope="scope">
          <el-button type="text" v-if="receivePaymentReqVos.length > 1" @click="removePayeeInfo(scope)" size="mini">{{ $t('common.remove') }}</el-button>
          <el-button type="text"  @click="editPayeeInfo(scope)" size="mini">{{ $t('common.edit') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="text" v-if="activeTab === 'payment' && !isAudit" @click="showDialogPayeeInfo">{{ $t('crm.addPayeeInfo') }}</el-button>
    <el-dialog :title="payeeInfoType=='create'?$t('crm.addPayeeInfo'):$t('crm.editPayeeInfo')" :visible.sync="dialogVisiblePayeeInfo" width="500px" :close-on-click-modal="false">
      <el-form :model="payeeInfoForm" ref="payeeInfoForm" label-width="120px">
        <el-form-item :label="$t('crm.payeeName')" prop="payeeName" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.payeeName')}`  }]">
          <el-input v-model="payeeInfoForm.payeeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankName')" prop="bankOfName" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.bankName')}`  }]">
          <el-input v-model="payeeInfoForm.bankOfName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankAccount')" prop="bankAccountNo" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.bankAccount')}`  }]">
          <el-input v-model="payeeInfoForm.bankAccountNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankAddress')" prop="bankAddress" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.bankAddress')}`  }]" >
          <el-input v-model="payeeInfoForm.bankAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.swiftCode')" prop="swiftCode" :rules="payeeInfoForm.payType === 2 ? [] : [{ required: true, message: `${$t('common.plzInput')}${$t('crm.swiftCode')}`  }]">
          <el-input v-model="payeeInfoForm.swiftCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.iban')" prop="iban">
          <el-input v-model="payeeInfoForm.iban"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.idNumber')" prop="idNo">
          <el-input v-model="payeeInfoForm.idNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.payMethod')" prop="payType">
          <el-radio-group v-model="payeeInfoForm.payType">
            <el-radio :label="1">{{$t('crm.overseaPayment')}}</el-radio>
            <el-radio :label="2">{{$t('crm.domesticPayment') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('crm.defaultOption')" prop="defaultOption">
          <el-radio-group v-model="payeeInfoForm.defaultOption">
            <el-radio :label="1">{{$t('common.yes')}}</el-radio>
            <el-radio :label="0">{{$t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('crm.phoneNumber')" prop="phoneNum">
          <el-input v-model="payeeInfoForm.phoneNum"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePayeeInfo = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitPayeeInfo">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <div class="stock-location" v-if="activeTab === 'stockLocation'">
      <div class="tr mb10" v-if="!isAudit">
        <el-button type="primary" @click="onClickAdd">{{ $t('common.add') }}</el-button>
      </div>
      <el-collapse v-model="activeAccordion" accordion v-loading="accordionLoading">
        <el-collapse-item :name="'collapse' + item.key" v-for="(item, index) in stockLocation" :key="item.key">
          <template slot="title">
            <div class="title">
              <!-- <span class="id">{{ $t('common.id2') }}：{{item.locationId}}</span> -->
              <span class="name">{{ $t('common.name') }}：{{item.stockLocation}}</span>
              <span class="status">{{ $t('common.status') }}：{{item.state === 1 ? $t('crm.using') : $t('crm.terminated') }}</span>
              <div class="right" v-if="!isAudit">
                <el-button type="text" v-if="!item.editFormStatus" @click="clickEdit($event, item)">{{ $t('common.edit') }}</el-button>
                <el-button type="text" v-if="item.state === 1" @click.stop="setState(item, 2)">{{ $t('common.disable') }}</el-button>
                <el-button type="text" v-else @click.stop="setState(item, 1)">{{ $t('common.open') }}</el-button>
              </div>
            </div>
          </template>
          <el-form :ref="'form' + item.key" class="searchForm pl20" :model="item" label-position="top" size="small">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.stockLocation2')" prop="stockLocation" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('common.stockLocation2')}` }]">
                  <el-input v-if="item.editFormStatus" v-model="item.stockLocation"></el-input>
                  <span v-else>{{ item.stockLocation }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('crm.shipFromStockLocation')" prop="shipFromLocationId" :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.shipFromStockLocation')}` }]">
                  <el-select v-if="item.editFormStatus" v-model="item.shipFromLocationId">
                    <el-option label="self" v-if="!item.locationId" :value="-1"></el-option>
                    <el-option v-for="si in comboList" :key="si.locationId" :label="si.stockLocation" :value="si.locationId"></el-option>
                  </el-select>
                  <span v-else>{{ comboMap[item.shipFromLocationId] }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('crm.registeredCompanyName')" prop="contactCompanyName" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.registeredCompanyName')}` }]">
                  <el-input v-if="item.editFormStatus" v-model="item.contactCompanyName"></el-input>
                  <span v-else>{{ item.contactCompanyName }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('crm.contactPerson')" prop="contactPersonName" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.contactPerson')}` }]">
                  <el-input v-if="item.editFormStatus" v-model="item.contactPersonName"></el-input>
                  <span v-else>{{ item.contactPersonName }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('crm.contactEmail')" prop="contactEmailAddress" :rules="[
                  { required: true, message: `${$t('common.plzInput')}${$t('crm.contactEmail')}` },
                  { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: $t('crm.emailFormatIncorrect'), trigger: 'blur' }
                ]">
                  <el-input v-if="item.editFormStatus" v-model="item.contactEmailAddress"></el-input>
                  <span v-else>{{ item.contactEmailAddress }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('crm.contactPhoneNumber')" prop="contactPhoneNumber" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.contactPhoneNumber')}` }]">
                  <div class="area-mobile" v-if="item.editFormStatus">
                    <el-input class="area-code" v-model="item.areaCode" :placeholder="$t('crm.areaCode')" maxlength="4" />
                    <el-input v-model="item.contactPhoneNumber"></el-input>
                  </div>
                  <span v-else>{{item.areaCode ? '+' + item.areaCode : ''}} {{ item.contactPhoneNumber }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.country')" prop="addressCountryCode" :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('common.country')}` }]">
                  <el-select v-if="item.editFormStatus" v-model="item.addressCountryCode" @change="() => onchangeCountry(item)">
                    <el-option v-for="item in countryList" :key="item.countryCode + item.addressCountryId" :label="item.name" :value="item.countryCode"></el-option>
                  </el-select>
                  <span v-else>{{ countryListMap[item.addressCountryCode] }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.city')" prop="addressCity" :rules="[{ required: true, message: `${$t('common.plzEnterSelect')}${$t('common.city')}` }]">
                  <el-select
                      v-if="item.editFormStatus"
                      v-model="item.addressCity"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="(query) => remoteMethod(query, item)"
                      :loading="cityLoading">
                    <el-option v-for="item in cityList" :key="item.cityName" :label="item.cityName" :value="item.cityName"></el-option>
                  </el-select>
                  <span v-else>{{ item.addressCity }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.postCode')" prop="addressPostalCode" :rules="[
                  { required: true, message: `${$t('common.plzInput')}${$t('common.postCode')}` },
                ]">
                  <el-input v-if="item.editFormStatus" v-model="item.addressPostalCode"></el-input>
                  <span v-else>{{ item.addressPostalCode }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.address') + '1'" prop="addressStreetlines" :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('common.address')}1` }]">
                  <el-input v-if="item.editFormStatus" v-model="item.addressStreetlines" maxlength="45"></el-input>
                  <span v-else>{{ item.addressStreetlines }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.address') + '2'" prop="addressStreetlines2">
                  <el-input v-if="item.editFormStatus" v-model="item.addressStreetlines2" maxlength="45"></el-input>
                  <span v-else>{{ item.addressStreetlines2 }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                <el-form-item class="mb10" :label="$t('common.address') + '3'" prop="addressStreetlines3">
                  <el-input v-if="item.editFormStatus" v-model="item.addressStreetlines3" maxlength="45"></el-input>
                  <span v-else>{{ item.addressStreetlines3 }}</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="item.editFormStatus">
                <el-form-item class="mb10" label=" " v-if="item.locationId">
                  <el-button type="primary" @click="update(item)">{{ $t('common.save') }}</el-button>
                  <el-button @click="onClickCancel(index)">{{ $t('common.cancel') }}</el-button>
                </el-form-item>
                <el-form-item class="mb10" label=" " v-else>
                  <el-button type="primary" @click="create(item)">{{ $t('common.save') }}</el-button>
                  <el-button @click="stockLocation.shift()">{{ $t('common.cancel') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="email" v-if="activeTab === 'notifyEmailSettings'">
      <h2>{{ $t('crm.afterSaleNotifyEmailSetting') }}</h2>
      <div class="mt10 mb20" v-if="!isAudit">
        <el-input v-model="input" style="width: 200px;margin-right: 10px" size="medium"></el-input>
        <el-button type="primary" icon="el-icon-plus" size="medium" :disabled="!input" @click="submitNotifyEmail" circle></el-button>
      </div>
      <div class="email-item" v-for="(item, index) in emailList" :key="item + index">{{ item }} <i v-if="!isAudit" @click="onClickRemove(index)" class="icon-close el-icon-circle-close"></i></div>
    </div>

    <div class="email" v-if="activeTab === 'workOrderAutoEmailSettings'">
      <div class="level-list">
        <el-checkbox disabled>L0</el-checkbox>
        <el-checkbox disabled>L1</el-checkbox>
        <el-checkbox v-for="item in levelList" :disabled="isAudit" :key="item.livello" v-model="item.autoSendFlag">{{ item.livello }}</el-checkbox>
      </div>
    </div>

    <el-table v-if="activeTab === 'vendorOrderPushEmail'" :data="orderNotificationEmailList" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
      <el-table-column :label="$t('common.email')">
        <template slot-scope="scope">
          <p v-for="(e, index) in scope.row.email.split(',')" :key="index">{{ e }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.orderPushTime')">
        <template slot-scope="scope">
          <template v-if="scope.row.orderTime">
            <p v-for="(t, index) in scope.row.orderTime" :key="index">
              {{ t.startTime }} ~ {{ t.endTime }} ({{ scope.row.timeZone }})
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="emailContentStr" :label="$t('crm.pushEmailContent')"></el-table-column>
      <el-table-column :label="$t('common.action')" v-if="!isAudit">
        <template slot-scope="scope">
          <el-button type="text" @click="editPushEmail(scope)" size="mini">{{ $t('common.edit') }}</el-button>
          <el-button type="text" @click="removePushEmail(scope)" size="mini">{{ $t('common.remove') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button v-if="activeTab === 'vendorOrderPushEmail' && !isAudit" class="mt10" type="text" @click="addPushEmail" size="mini">{{ $t('crm.addPushEmail') }}</el-button>
    <el-dialog :title="$t('crm.orderNotifyEmail')" :visible.sync="dialogVisiblePushEmail" width="700px" :close-on-click-modal="false">
      <p class="mb10">{{ $t('common.email') }}</p>
      <el-input v-model="addContactValue" style="width: 200px" size="medium">
        <el-button v-if="addContactList.length < 10" @click="addContact" slot="append" icon="el-icon-circle-plus-outline"></el-button>
      </el-input>
      <span>{{ $t('crm.canInputEmailsMost') }}</span>
      <div class="push-email-group mt10">
        <div class="push-email-item" v-for="(item, index) in addContactList" :key="index">
          <i class="el-icon-close" @click="removeContact(item)"></i>
          {{ item }}
        </div>
      </div>

      <p class="mt20 mb10">
        {{ $t('crm.orderEmailTime') }}
        <el-tooltip
          effect="dark"
          :content="$t('crm.orderEmailTip')"
          placement="top-start"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
        <span style="margin-left: 113px">{{ $t('crm.orderEmailTip2') }}</span>
      </p>
      <div class="push-email-group">
        <div class="push-email-item" v-for="(item, index) in orderTimeList" :key="index">
          <i class="el-icon-close" @click="deleteOrderList(item)"></i>
          {{ item.content }}
        </div>
      </div>
      <el-button type="text" v-if="orderTimeList.length < 5" @click="(editOrderTime = true),
            (weekStart = 'Sunday'),
            (timeStart = '00:00'),
            (weekEnd = 'Saturday'),
            (timeEnd = '23:59')" size="mini">+ {{ $t('crm.addTime') }}</el-button>

      <p class="mt20 mb10">{{ $t('crm.timeZone') }}</p>
      <el-select size="medium" v-model="currTimeZone" style="width: 200px">
        <el-option v-for="item in timeZoneList" :key="item" :label="item" :value="item"></el-option>
      </el-select>

      <p class="mt20 mb10">{{ $t('crm.pushEmailContent') }}</p>
      <el-checkbox v-for="ct in ContentTypeList" :key="ct.code" v-model="ct.checked">{{ ct.explain }}</el-checkbox>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePushEmail = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitPushEmail">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.selectOrderTime')" :visible.sync="editOrderTime" width="600px" :close-on-click-modal="false">
      <el-select v-model="weekStart" style="width: 110px">
        <el-option v-for="item in weekList" :key="item" :value="item" :label="item"></el-option>
      </el-select>
      <el-time-picker
          value-format="HH:mm"
          format="HH:mm"
          v-model="timeStart"
          :clearable="false"
          style="width: 110px"
      ></el-time-picker>
      ~
      <el-select v-model="weekEnd" style="width: 110px">
        <el-option v-for="item in weekList" :key="item" :value="item" :label="item"></el-option>
      </el-select>
      <el-time-picker
          value-format="HH:mm"
          format="HH:mm"
          v-model="timeEnd"
          :clearable="false"
          style="width: 110px"
      ></el-time-picker>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editOrderTime = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="saveTimeZone">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('crm.submitStoreInfo')" :visible.sync="showCreateDialog" width="400px" :close-on-click-modal="false">
      {{ $t('crm.selectReviewer') }}
      <el-select v-model="ruleForm.approvalUserId" style="width: 150px">
        <el-option v-for="item in approvalUserList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateDialog = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitSubmitStore">{{ $t('crm.submitAudit') }}</el-button>
      </span>
    </el-dialog>

    <el-row v-show="activeTab === 'logisticsRelated'">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="ruleForm" :rules="rules" ref="logisticsRelatedForm" label-width="200px">
          <el-form-item :label="$t('crm.deadlineForDay')" prop="cutOffTime" :rules="[{ required: ruleForm.vendorType != 1, message: `${this.$t('common.plzSelect')}${this.$t('crm.deadlineForDay')}` }]">
            <el-time-picker
              value-format="HH:mm"
              format="HH:mm"
              v-model="ruleForm.cutOffTime"
              :clearable="false"
              style="width: 100%"
              :disabled="isAudit"
            ></el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('crm.confirmTimeFromMerchant')" prop="latestConfirmDay" :rules="[{ required: ruleForm.vendorType != 1, message: `${this.$t('common.plzSelect')}${this.$t('crm.confirmTimeFromMerchant')}` }, { validator: this.latestConfirmDayValidator }]">
            <el-row :gutter="0">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-select v-model="ruleForm.latestConfirmDay" :disabled="isAudit || disabled">
                  <el-option v-for="(item, index) in 31" :key="item" :label="'T+'+index" :value="index + ''"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-time-picker
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="ruleForm.latestConfirmTime"
                  :clearable="false"
                  style="width: 100%"
                  :disabled="isAudit"
                ></el-time-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('crm.shippingDeadline')" prop="latestDeliveryDay" :rules="[{ required: ruleForm.vendorType != 1, message: `${this.$t('common.plzSelect')}${this.$t('crm.shippingDeadline')}` }, { validator: this.latestDeliveryDayValidator }]">
            <el-row :gutter="0">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-select v-model="ruleForm.latestDeliveryDay" :disabled="isAudit || disabled">
                  <el-option v-for="(item, index) in 31" :key="item" :label="'T+'+index" :value="index + ''"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-time-picker
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="ruleForm.latestDeliveryTime"
                  :clearable="false"
                  style="width: 100%"
                  :disabled="isAudit"
                ></el-time-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('crm.orderShippingDay')" prop="deliveryTime" :rules="[{ required: ruleForm.vendorType != 1, message: `${this.$t('common.plzSelect')}${this.$t('crm.orderShippingDay')}` }]">
            <el-select v-model="ruleForm.deliveryTime" multiple :disabled="isAudit || disabled">
              <el-option v-for="(item, index) in 7" :key="item" :label="$t(`common.week${index}`)" :value="item + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.tmsLogisticsRoute')" prop="logisticsRoute">
            <el-select v-model="ruleForm.logisticsRoute" :disabled="isAudit">
              <el-option v-for="item in logisticsRouteList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.logisticsType')" prop="logisticsType">
            <el-select v-model="ruleForm.logisticsType" :disabled="isAudit">
              <el-option v-for="item in logisticsTypeList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.expressConfig')" prop="expressConfig">
            <el-input v-model="ruleForm.expressConfig" placeholder="支持的物流公司，例如：DHL、UPS、Fedex、SF" :readonly="isAudit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.logisticsSettlementMethod')" prop="logisticsSettlementType">
            <el-select v-model="ruleForm.logisticsSettlementType" :disabled="isAudit">
              <el-option v-for="item in logisticsSettlementTypeList" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div class="footer-bar" v-if="isAudit">
      <el-button type="primary" size="small" @click="submitAudit(1)">{{ $t('crm.passTheAudit') }}</el-button>
      <el-button size="small" @click="submitAudit(2)">{{ $t('crm.dismiss') }}</el-button>
    </div>
    <div class="footer-bar" v-if="isShow">
      <el-button size="small" @click="$router.back()">{{ $t('common.back') }}</el-button>
    </div>
    <div class="footer-bar" v-if="!isAudit && !isShow">
      <el-button type="primary" size="small" @click="submitStore">{{ $t('common.submit') }}</el-button>
      <el-button size="small" @click="$router.back()">{{ $t('common.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import {
  getGroupListByName,
  getDictList,
  queryEmailConfiguration,
  getEmailContentType,
  createVendor,
  getApprovalVendorDetail,
  approvalVendor,
  getCRMVendorList,
  getVendorConfigInfo,
} from './api';
import {
  getVendorType,
  getBoutiqueCountryList,
  getUnitList,
  getUserList,
  getBusinessRegionList,
  getBoutiqueCityList,
  queryStockLocation,
  getXiaJiTongBuList,
} from '../../buyershop/cn/api'
export default {
  components: {
  },
  data() {
    return {
      payeeInfoType:'create', //收款信息编辑类型 create edit
      currentEditindex:0,
      isAudit: false,
      isEdit: false,
      isShow: false,
      countryList: [],
      countryListMap: {},
      groupByList: [],
      vendorTypeList: [],
      unitList: [],
      boutiqueBdList: [],
      boutiqueBdListMap: {},
      businessRegionList: [],
      paymentMethodList: [],
      paymentTimingList: [],
      productSourceType: [],
      supplyPriceMethod: [],
      vendorOperationType: [],
      approvalUserList: [],
      logisticsRouteList: [],
      logisticsTypeList: [],
      logisticsSettlementTypeList: [],
      tongbuArr: [],
      xiajiArr: [],
      ruleForm: {
        vendorName: null,
        vendorType: null,
        sellerUserId: null,
        addressCountryId: null,
        originalPriceUnit: null,
        retailPriceTax: null,
        vendorSupplyPriceMethod: null,
        boutiquePriceTax: null,
        provideRetailPrice: null,
        isPreSale: null,
        isSignSla: null,
        signSlaTimeStamp: null,
        boutiqueBdId: null,
        boutiqueBd: null,
        boutiqueAssistantId: null,
        boutiqueAssistant: null,
        boutiqueAssistantTwoId: null,
        boutiqueAssistantTwo: null,
        businessRegionId: null,
        groupName: null,
        drawback: null,
        cutOffTime: '16:00',
        latestConfirmDay: null,
        latestConfirmTime: '23:59',
        latestDeliveryDay: null,
        latestDeliveryTime: '23:59',
        deliveryTime: [],
        vendorOperationType: null,
        approvalUserId: null,
        logisticsRoute: null,
        logisticsType: null,
        expressConfig: null,
        logisticsSettlementType: null,
        wholesaleType: null
      },
      rules: {
        vendorName: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.vendorName')}` }],
        vendorType: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.vendorType')}` }],
        sellerUserId: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.personalSellerIMID')}` }],
        // vendorProductSourceType: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.personalSellerIMID')}` }],
        addressCountryId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('common.country')}` }],
        originalPriceUnit: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.currency')}` }],
        retailPriceTax: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.retailPriceIncludesTax')}` }],
        vendorSupplyPriceMethod: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.pricingConnectivityMethod')}` }],
        boutiquePriceTax: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.supplyPriceIncludesTax')}` }],
        provideRetailPrice: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.provideHangingPrice')}` }],
        isPreSale: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.supplyPriceIncludesTax')}` }],
        isSignSla: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.contractOrSLASigned')}` }],
        signSlaTimeStamp: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.contractTime')}` }],
        boutiqueBdId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.imRepresentative')}` }],
        boutiqueAssistantId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.imAssistantRepresentative')}` }],
        businessRegionId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.vendorRegion')}` }],
        groupName: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.parentCompanyName')}(${this.$t('crm.businessEntityName')})` }],
        // drawback: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.ifIMCanGetTaxBack')}` }],
        wholesaleOneVendorId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.wholesaleField1')}` }],
        marketplaceVendorId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.wholesaleField2')}` }],
        vendorOperationType: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.operationType')}` }],
        wholesaleType: [{ required: true, message: "请选择货单类型" }]
      },
      activeTab: 'billingInfo',
      invoiceDto: {
        companyName: null,
        businessLicenseNumber: null,
        registeredPerson: null,
        contactPhone: null,
        contactEmail: null,
        addressCountryId: null,
        city: null,
        postalCode: null,
        businessLicenseLocation: null,
      },
      // invoiceDtoRules: {
      //   companyName: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.companyName')}` }],
      //   businessLicenseNumber: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.vatNumber')}` }],
      //   registeredPerson: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.contactPerson')}` }],
      //   addressCountryId: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('common.country')}` }],
      //   businessLicenseLocation: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('common.address')}` }],
      // },
      vendorPayment: {
        paymentMethod: null,
        depositAmount: null,
        paymentTiming: null,
        paymentTimingTime: null,
        paymentTimingRemark: null,
        paymentMethodRemark: null,
        settleCurrency:null
      },
      vendorPaymentRules: {
        paymentMethod: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.paymentMethod')}` }],
        paymentTiming: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.paymentTiming')}` }, { validator: this.paymentTimingValidator }],
        paymentTimingTime: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.settlementCycle')}` }],
      },
      receivePaymentReqVos: [],
      dialogVisiblePayeeInfo: false,
      payeeInfoForm: {
        payeeName: '',
        bankOfName: '',
        bankAccountNo: '',
        swiftCode: '',
        iban: '',
        bankAddress:"",
        payType:1,//付款方式 1:境外付款 2:境内付款'
        idNo:'',
        phoneNum:''
      },
      stockLocation: [],
      activeAccordion: null,
      accordionLoading: false,
      comboList: [],
      comboMap: {},
      cityLoading: false,
      cityList: [],
      cityList2: [],
      input: '',
      emailList: [],
      levelList: [],
      orderNotificationEmailList: [],
      dialogVisiblePushEmail: false,
      currTimeZone: '',
      weekStart: null,
      weekEnd: null,
      timeStart: '00:00',
      timeEnd: '23:59',
      weekMap: {
        Sunday: 1,
        Monday: 2,
        Tuesday: 3,
        Wednesday: 4,
        Thursday: 5,
        Friday: 6,
        Saturday: 7
      },
      weekList: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      addContactValue: '',
      addContactList: [],
      orderTimeList: [],
      ContentTypeList: [],
      ContentTypeListMap: {},
      timeZoneList: ["GMT+1", "GMT-4", "GMT+8"],
      editOrderTime: false,
      showCreateDialog: false,
      copyTargetVendorId: null,
      vendorList: [],
      disabled: false,
      isPreSaleDisabled: false
    };
  },
  mounted() {
    if (this.$route.path.indexOf('/crm/cn/store/audit/') === 0) {
      this.isAudit = true;
    }
    if (this.$route.path.indexOf('/crm/cn/store/edit/') === 0) {
      this.isEdit = true;
    }
    if (this.$route.path.indexOf('/crm/cn/store/show/') === 0) {
      this.isShow = true;
      this.isAudit = true;
    }
    this.stockLocationCurrKey = -1;
    if (this.$route.params.id) {
      this.getDetail();
    }
    this.init();
  },
  methods: {
    init() {
      getVendorType().then(res => {
        if (res.data) {
          this.vendorTypeList = res.data.data.filter(item => item.value !== 4 && item.value !== 1 && item.value !== 6);
        }
      });
      getBoutiqueCountryList().then(res => {
        if (res.data) {
          const map = {};
          this.countryList = (res.data.data || []).map(item => {
            map[item.countryCode] = item.name;
            return item;
          }).filter(item => {
            if (item.addressCountryId != 100) {
              return true;
            }
            return false;
          });
          this.countryListMap = map;
        }
      });
      getUnitList().then(res => {
        if (res.data) {
          this.unitList = res.data.data;
        }
      });
      getUserList().then(res => {
        const map = {};
        this.boutiqueBdList = (res.data || []).map(item => {
          map[item.deptUserId] = item.deptUserName;
          return {
            label: item.deptUserName,
            value: item.deptUserId,
          };
        });
        this.boutiqueBdListMap = map;
      });
      getBusinessRegionList().then(res => {
        if (res.data) {
          this.businessRegionList = (res.data.data || []).filter(item => {
            // 过滤奥莱村 寄售 识季测试业务
            return item.businessRegionId !== 8 && item.businessRegionId !== 11 && item.businessRegionId !== 12
          }).map(item => ({
            label: item.businessRegionName,
            value: item.businessRegionId,
          }));
        }
      });
      getGroupListByName({
        groupName: '',
      }).then(res => {
        if (res.data) {
          this.groupByList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'crm_payment_method',
      }).then(res => {
        if (res.data && res.data.success) {
          this.paymentMethodList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'crm_payment_timing',
      }).then(res => {
        if (res.data && res.data.success) {
          this.paymentTimingList = res.data.data || [];
        }
      });
      if (this.$route.path.indexOf('/crm/cn/create') === 0) {
        queryEmailConfiguration().then(res => {
          if (res.data && res.data.success) {
            this.levelList = (res.data.data || []).map(item => ({
              autoSendFlag: false,
              livello: item,
            }));
          }
        });
      }
      getDictList({
        parentCode: 'product_source_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.productSourceType = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'supply_price_method',
      }).then(res => {
        if (res.data && res.data.success) {
          this.supplyPriceMethod = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'vendor_operation_type',
      }).then(res => {
        if (res.data && res.data.success) {
          console.log(res.data.data)
          this.vendorOperationType = res.data.data.filter(item => {
            return item.dictCode !== '9' && item.dictCode !== '17'
          }) || [];
        }
      });
      getEmailContentType().then(res => {
        if (res.data && res.data.success) {
          const map = {};
          this.ContentTypeList = (res.data.data || []).map(item => {
            map[item.code] = item.explain;
            return {
              code: item.code,
              explain: item.explain,
              checked: true,
            };
          });
          this.ContentTypeListMap = map;
          this.checkContentFormat();
        }
      })
      getDictList({
        parentCode: 'approval_user',
      }).then(res => {
        if (res.data && res.data.success) {
          this.approvalUserList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'logistics_route',
      }).then(res => {
        if (res.data && res.data.success) {
          this.logisticsRouteList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'logistics_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.logisticsTypeList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'logistics_settlement_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.logisticsSettlementTypeList = res.data.data || [];
        }
      });
      getXiaJiTongBuList({ vendorType: 0 }).then(res => {
        if (res.success && res.data) {
          this.tongbuArr = res.data;
        }
      });
      getXiaJiTongBuList({ vendorType: 1 }).then(res => {
        if (res.success && res.data) {
          this.xiajiArr = res.data;
        }
      });
      getCRMVendorList().then(res => {
        if (res.data) {
          this.vendorList = (res.data.data || []).map(item => ({
            label: item.vendorName,
            value: item.vendorId,
          }));
        }
      })
    },
    querySearch(queryString, cb) {
      var restaurants = this.groupByList;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.groupName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    changeAddressCountryId(val) {
      this.invoiceDto.addressCountryId = val;
      this.changeInvoiceAddressCountry(val);
    },
    changeInvoiceAddressCountry(val) {
      this.invoiceDto.city = null;
      this.countryList.filter(item => {
        if (item.addressCountryId === val) {
          this.invoiceDto.areaCode = item.areaCode;
          return true;
        }
        return false;
      })
      this.remoteMethod2('');
    },
    latestConfirmDayValidator(rule, value, callback) {
      if (!this.ruleForm.latestConfirmTime) {
        callback(new Error(`${this.$t('common.plzSelect')}${this.$t('crm.confirmTimeFromMerchant')}`));
      } else {
        callback();
      }
    },
    latestDeliveryDayValidator(rule, value, callback) {
      if (!this.ruleForm.latestDeliveryTime) {
        callback(new Error(`${this.$t('common.plzSelect')}${this.$t('crm.shippingDeadline')}`));
      } else {
        callback();
      }
    },
    handleClick() {
      this.$nextTick(() => {
        this.valiStockLocation();
      })
    },
    changePaymentMethod() {
      this.$refs.vendorPaymentForm.clearValidate('depositAmount');
    },
    changePaymentTiming() {
      if (this.vendorPayment.paymentTiming !== 'crm_payment_others') {
        this.vendorPayment.paymentTimingRemark = '';
      }
      if (this.vendorPayment.paymentTiming !== 'crm_payment_week') {
        this.vendorPayment.paymentTimingTime = null;
      }
    },
    paymentTimingValidator(rule, value, callback) {
      if (value === 'crm_payment_others' && !this.vendorPayment.paymentTimingRemark) {
        callback(new Error(this.$t('crm.otherPaymentTiming')));
      } else {
        callback();
      }
    },
    removePayeeInfo(scope) {
      this.receivePaymentReqVos.splice(scope.$index, 1);
    },
    editPayeeInfo(scope){
      console.error(scope,'sss---')
       this.payeeInfoType = 'edit';
       this.payeeInfoForm = {...scope.row};
       this.currentEditindex = scope.$index;//当前编辑下标
       this.dialogVisiblePayeeInfo = true;
    },
    showDialogPayeeInfo() {
      this.payeeInfoType = 'create';
      this.payeeInfoForm = {
        payeeName: '',
        bankOfName: '',
        bankAccountNo: '',
        swiftCode: '',
        iban: '',
        bankAddress:"",
        payType:1,//付款方式 1:境外付款 2:境内付款'
        idNo:'',
        phoneNum:'',
        defaultOption: 1
      };
      this.dialogVisiblePayeeInfo = true;
      this.$nextTick(() => {
        this.$refs.payeeInfoForm.resetFields();

      })
    },
    submitPayeeInfo() {
      const that = this;

      this.$refs.payeeInfoForm.validate((vali) => {
        if (vali) {
          if(this.payeeInfoType == 'create'){
            this.dialogVisiblePayeeInfo = false;
            that.receivePaymentReqVos.push({
              ...this.payeeInfoForm,
              enabled: true,
            });
          }
          else{ //编辑
            let currentEditindex = that.currentEditindex;
            let payeeInfoForm = that.payeeInfoForm;
            that.$set(that.receivePaymentReqVos,currentEditindex,payeeInfoForm);
            that.dialogVisiblePayeeInfo = false;

          }

        }
      })
    },
    onClickAdd() {
      if (!this.stockLocation.some(item => item.editFormStatus)) {
        this.stockLocationCurrKey++;
        this.stockLocation.unshift({
          locationId: null,
          addressCity: "",
          addressCountryCode: "",
          addressPostalCode: "",
          addressStreetlines: "",
          addressStreetlines2: "",
          addressStreetlines3: "",
          areaCode: "",
          contactCompanyName: "",
          contactEmailAddress: "",
          contactPersonName: "",
          contactPhoneNumber: "",
          countryName: "",
          fullAddress: "",
          shipFromLocationId: null,
          state: 1,
          stockLocation: "",
          editFormStatus: true,
          aaaCountryId: null,
          enabled: true,
          key: this.stockLocationCurrKey,
        });
        this.activeAccordion = 'collapse' + this.stockLocationCurrKey;
        this.$nextTick(() => {
          this.$refs[`form${this.stockLocationCurrKey}`][0].clearValidate();
        })
      } else {
        this.activeAccordion = null;
      }
    },
    clickEdit(e, item) {
      if (this.activeAccordion === 'collapse' + item.key) {
        e.stopPropagation();
      }
      this.editStockLocationBak = JSON.parse(JSON.stringify(item));
      item.editFormStatus = true;
      this.onchangeCountry(item, true);
    },
    onchangeCountry(item, init) {
      this.countryList.filter(c => {
        if (c.countryCode === item.addressCountryCode) {
          item.aaaCountryId = c.addressCountryId;
          item.areaCode = c.areaCode;
          return true;
        }
        return false;
      })
      if (!init) {
        item.addressCity = null;
        this.cityList = [];
      }
      this.remoteMethod('', item);
    },
    remoteMethod2(query) {
      this.cityLoading = true;
      getBoutiqueCityList({
        countryId: this.invoiceDto.addressCountryId,
        cityCode: query,
      }).then(res => {
        if (res.data && res.data.data) {
          this.cityList2 = res.data.data;
        }
        this.cityLoading = false;
      })
    },
    remoteMethod(query, item) {
      this.cityLoading = true;
      getBoutiqueCityList({
        countryId: item.aaaCountryId,
        cityCode: query,
      }).then(res => {
        if (res.data && res.data.data) {
          this.cityList = res.data.data;
        }
        this.cityLoading = false;
      })
    },
    onClickCancel(index) {
      this.stockLocation[index] = this.editStockLocationBak;
    },
    getComboList() {
      queryStockLocation({
        vendorId: this.$route.query.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          const map = {'-1':'self'};
          this.comboList = res.data.data.map((item) => {
            map[item.locationId] = item.stockLocation;
            if (item.state === 2) {
              item.disabled = true;
            }
            return item;
          });
          this.comboMap = map;
        }
      })
    },
    update(item) {
      if (item.addressCountryCode && this.getCountryRegex(item.addressCountryCode)) {
        const regex = this.getCountryRegex(item.addressCountryCode);
        if (!regex.test(item.addressPostalCode)) {
          this.$message.error(this.$t('crm.incorrectPostalCodeFormat'));
          return;
        }
      }
      this.$refs['form' + item.key][0].validate((valid) => {
        if (valid) {
          this.activeAccordion = null;
          item.editFormStatus = false;
        }
      })
    },
    create(item) {
      if (item.addressCountryCode && this.getCountryRegex(item.addressCountryCode)) {
        const regex = this.getCountryRegex(item.addressCountryCode);
        if (!regex.test(item.addressPostalCode)) {
          this.$message.error(this.$t('crm.incorrectPostalCodeFormat'));
          return;
        }
      }
      this.$refs['form' + item.key][0].validate((valid) => {
        if (valid) {
          this.activeAccordion = null;
          item.editFormStatus = false;
        }
      })
    },
    setState(item, state) {
      item.state = state;
    },
    submitNotifyEmail() {
      if (!this.input) {
        return;
      }
      this.emailList.push(this.input);
      this.input = '';
    },
    onClickRemove(index) {
      this.emailList.splice(index, 1);
    },
    editPushEmail(scope) {
      const item = scope.row;
      this.currEditIndex = scope.$index;
      this.isEditEmail = true;

      this.addContactValue = "";
      this.addContactList = item.email.split(",");

      this.orderTimeList = [];
      const orderTime = item.orderTime;
      orderTime.forEach((ot, i) => {
        this.orderTimeList.push({
          startTime: ot.startTime,
          endTime: ot.endTime,
          id: i,
          content: ot.startTime + " ~ " + ot.endTime
        });
      });

      this.currTimeZone = item.timeZone;

      var ids = item.emailContent.split(",");
      this.ContentTypeList.forEach(ct => {
        ct.checked = false;

        ids.forEach(id => {
          if (id == ct.code) {
            ct.checked = true;
          }
        });
      });

      this.dialogVisiblePushEmail = true;
    },
    removePushEmail(scope) {
      this.orderNotificationEmailList.splice(scope.$index, 1);
    },
    addPushEmail() {
      this.isEditEmail = false;

      this.addContactValue = "";
      this.addContactList = [];
      this.orderTimeList = [];
      this.ContentTypeList.forEach(ct => {
        ct.checked = true;
      });

      this.orderTimeList = [];
      this.addContactList = [];
      this.currTimeZone = null;

      this.dialogVisiblePushEmail = true;
    },
    addContact() {
      if (this.addContactValue === "") {
        this.$message('email can not null');
        return;
      }
      var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!reg.test(this.addContactValue)) {
        this.$message('Incorrect mailbox format');
        return;
      }
      if (this.addContactList.indexOf(this.addContactValue) > -1) {
        this.$message('mail cannot be repeated');
        return;
      }
      this.addContactList.push(this.addContactValue);
      this.addContactValue = "";
    },
    removeContact(item) {
      var index = this.addContactList.indexOf(item);
      if (index > -1) {
        this.addContactList.splice(index, 1);
      }
    },
    saveTimeZone() {
      if (
          !this.weekStart ||
          !this.weekEnd ||
          !this.timeStart ||
          !this.timeEnd
      ) {
        this.$message('Please select all time');
        return;
      }
      if (this.weekMap[this.weekStart] > this.weekMap[this.weekEnd]) {
        this.$message('The latter time must be greater than the previous time');
        return;
      } else if (this.weekStart == this.weekEnd) {
        if (this.timeStart > this.timeEnd) {
          this.$message('The latter time must be greater than the previous time');
          return;
        } else if (this.timeStart == this.timeEnd && this.timeStart >= this.timeEnd) {
          this.$message('The latter time must be greater than the previous time');
          return;
        }
      }

      //开始时间2
      const currws2 = this.weekMap[this.weekStart];
      const currts2 = this.timeStart;
      const currstart2 = currws2 + currts2;
      //结束时间2
      const currwe2 = this.weekMap[this.weekEnd];
      const currte2 = this.timeEnd;
      const currend2 = currwe2 + currte2;

      for (let i = 0; i < this.orderTimeList.length; i++) {
        //开始时间1
        const st1 = this.orderTimeList[i].startTime;
        const ws1 = this.weekMap[st1.split(" ")[0]];
        const ts1 = st1.split(" ")[1];
        const start1 = ws1 + ts1;
        //结束时间1
        const st2 = this.orderTimeList[i].endTime;
        const we1 = this.weekMap[st2.split(" ")[0]];
        const te1 = st2.split(" ")[1];
        const end1 = we1 + te1;

        if (!(currend2 <= start1 || currstart2 >= end1)) {
          this.$message('order time cannot overlap');
          return;
        }
      }

      this.orderTimeList.push({
        id: Date.now(),
        content:
            this.weekStart + " " + currts2 + " ~ " + this.weekEnd + " " + currte2,
        startTime: this.weekStart + " " + currts2,
        endTime: this.weekEnd + " " + currte2
      });
      this.editOrderTime = false;
    },
    deleteOrderList(index) {
      this.orderTimeList.splice(index, 1);
    },
    submitPushEmail() {
      if (this.addContactValue && this.addContactList.length < 10) {
        this.addContact();
      }
      if (this.addContactList.length == 0) {
        this.$message('Please add email');
        return false;
      }
      if (this.orderTimeList.length == 0) {
        this.$message('Please add order time');
        return false;
      }
      if (!this.currTimeZone && this.currTimeZone != 0) {
        this.$message('Please select time zone');
        return false;
      }
      const ids = [];
      const emailContentArr = [];
      this.ContentTypeList.forEach(ct => {
        if (ct.checked) {
          ids.push(ct.code);
          emailContentArr.push(ct.explain);
        }
      });
      if (ids.length == 0) {
        this.$message('Please select the email content');
        return false;
      }
      var otList = [];
      this.orderTimeList.forEach(ot => {
        otList.push({
          startTime: ot.startTime,
          endTime: ot.endTime
        });
      });
      var params = {
        email: this.addContactList.join(","),
        orderTime: otList,
        timeZone: this.currTimeZone,
        emailContent: ids.join(","),
        emailContentStr: emailContentArr.join(',')
      };
      if (this.isEditEmail) {
        this.orderNotificationEmailList[this.currEditIndex].email = params.email;
        this.orderNotificationEmailList[this.currEditIndex].orderTime = params.orderTime;
        this.orderNotificationEmailList[this.currEditIndex].timeZone = params.timeZone;
        this.orderNotificationEmailList[this.currEditIndex].emailContent = params.emailContent;
        this.orderNotificationEmailList[this.currEditIndex].emailContentStr = params.emailContentStr;
        this.dialogVisiblePushEmail = false;
      } else {
        this.orderNotificationEmailList.push(params);
        this.dialogVisiblePushEmail = false;
      }
    },
    getStockLocationName(stockLocationList, id) {
      let stockLocationName = '';
      stockLocationList.some((item) => {
        if (item.stockLocationId === id) {
          stockLocationName = item.stockLocation;
          return true;
        }
        return false;
      });
      return stockLocationName;
    },
    valiStockLocation() {
      let editKey = null;
      if (this.stockLocation.some(item => {
        if (item.editFormStatus) {
          editKey = item.key;
          return true;
        }
        return false;
      })) {
        if (this.$refs[`form${editKey}`] && this.$refs[`form${editKey}`][0]) {
          this.$refs[`form${editKey}`][0].validate();
        }
      }
      return editKey;

    },
    async submitStore() {
      this.$refs.ruleForm.validate(vali1 => {
        if (vali1) {
          this.$refs.vendorPaymentForm.validate(vali2 => {
            if (vali2) {
              if (this.ruleForm.vendorType == 0 && this.ruleForm.businessRegionId === 4 && this.receivePaymentReqVos.length === 0) {
                this.$message(`${this.$t('common.plzAdd')}${this.$t('crm.payeeInfo')}`)
                return;
              }
              if (this.ruleForm.vendorType == 0 && [1, 2, 5].includes(this.ruleForm.businessRegionId) && this.stockLocation.length === 0) {
                this.$message(`${this.$t('common.plzAdd')}${this.$t('common.stockLocation')}`)
                return;
              }
              if (this.valiStockLocation()) {
                this.$message(this.$t('crm.fullFormStockLocationTip'))
                return;
              }
              this.$refs.logisticsRelatedForm.validate(vali3 => {
                if (vali3) {
                  this.showCreateDialog = true;
                } else {
                  this.$message(this.$t('crm.fullFormLogisticsRelatedTip'));
                }
              })
            } else {
              this.$message(this.$t('crm.fullFormPaymentTip'));
            }
          })
        } else {
          this.$message(this.$t('common.fullFormTip'));
        }
      });
    },
    submitSubmitStore() {
      if (!this.ruleForm.approvalUserId) {
        this.$message(this.$t('crm.pleaseSelectReviewer'));
        return;
      }

      if(this.ruleForm.vendorType !== 3){
        this.ruleForm.marketplaceVendorId = null
        this.ruleForm.wholesaleOneVendorId = null
      }

      createVendor({
        crmCreateVendorVO: {
          ...this.ruleForm,
          boutiqueAftermarketEmail: this.emailList.join(','),
          crmPrepareVendorId: this.$route.params.id,
        },
        receivePaymentReqVos: this.receivePaymentReqVos,
        invoiceDto: this.invoiceDto,
        stockLocation: this.stockLocation.map(item => {
          if (item.shipFromLocationId === -1) {
            item.shipFromLocationName = 'self';
          } else {
            item.shipFromLocationName = this.getStockLocationName(this.comboList, item.shipFromLocationId);
          }
          return item;
        }),
        items: this.levelList,
        orderNotificationEmailList: this.orderNotificationEmailList.map(item => ({
          ...item,
          orderTime: JSON.stringify(item.orderTime),
        })),
        vendorPayment: this.vendorPayment,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$router.back();
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
        }
      })
    },
    getDetail() {
      getApprovalVendorDetail({
        crmPrepareVendorId: this.$route.params.id,
      }).then(res => {
        if (res.data && res.data.data) {
          res.data.data.crmCreateVendorVO.vendorOperationType = res.data.data.crmCreateVendorVO.vendorOperationType ? res.data.data.crmCreateVendorVO.vendorOperationType + '' : null;
          // res.data.data.crmCreateVendorVO.vendorProductSourceType = res.data.data.crmCreateVendorVO.vendorProductSourceType + '';
          res.data.data.crmCreateVendorVO.vendorSupplyPriceMethod = res.data.data.crmCreateVendorVO.vendorSupplyPriceMethod + '';
          res.data.data.crmCreateVendorVO.approvalUserId = res.data.data.crmCreateVendorVO.approvalUserId + '';

          this.ruleForm = res.data.data.crmCreateVendorVO;
          this.emailList = res.data.data.crmCreateVendorVO.boutiqueAftermarketEmail.split(',');
          this.receivePaymentReqVos = res.data.data.receivePaymentReqVos;
          this.invoiceDto = res.data.data.invoiceDto;
          this.stockLocation = res.data.data.stockLocation.map((item, index) => ({
            ...item,
            key: index,
          }));
          this.stockLocationCurrKey = this.stockLocation.length - 1;
          this.levelList = res.data.data.items;
          this.orderNotificationEmailList = res.data.data.orderNotificationEmailList.map(item => {
            const row = {
              ...item,
              orderTime: JSON.parse(item.orderTime || '{}'),
              emailContentStr: '',
            };
            if (this.ContentTypeList.length > 0) {
              this.is_format = true;
              row.emailContentStr = this.getContentStr(item.emailContent);
            }
            return row;
          });
          this.vendorPayment = res.data.data.vendorPayment;
        }
      });
    },
    checkContentFormat() {
      if (!this.is_format) {
        this.orderNotificationEmailList = this.orderNotificationEmailList.map(item => ({
          ...item,
          emailContentStr: this.getContentStr(item.emailContent),
        }));
      }
    },
    getContentStr(ids) {
      const arr = ids.split(',');
      return arr.map(id => {
        return this.ContentTypeListMap[id];
      }).join(',');
    },
    submitAudit(type) {
      this.$confirm(`<span style="color:red">${type === 1 ? this.$t('crm.auditPassTip2') : this.$t('crm.auditDismiss2')}</span>${this.$t('crm.doYouContinue')}`, type === 1 ? this.$t('crm.auditPassConfirmTip') : this.$t('crm.auditDismissConfirmTip'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        approvalVendor({
          crmPrepareVendorId: this.$route.params.id,
          status: type,
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(this.$t('common.submitSuccess'));
            this.$router.back();
          } else {
            this.$message.error(res.data.message || this.$t('common.systemError'));
          }
        })
      }).catch(() => {});

    },
    changeBoutiqueBdId() {
      this.ruleForm.boutiqueBd = this.boutiqueBdListMap[this.ruleForm.boutiqueBdId];
    },
    changeBoutiqueAssistantId() {
      this.ruleForm.boutiqueAssistant = this.boutiqueBdListMap[this.ruleForm.boutiqueAssistantId];
    },
    changeBoutiqueAssistantTwoId() {
      this.ruleForm.boutiqueAssistantTwo = this.boutiqueBdListMap[this.ruleForm.boutiqueAssistantTwoId];
    },
    onChangeVendorType(val) {
      if (val != 0) {
        this.ruleForm.boutiqueAssistantTwoId = null;
        this.ruleForm.boutiqueAssistantTwo = null;
      }
      if (val == 7) {
        this.disabled = true;
        this.ruleForm.latestConfirmDay = "7"
        this.ruleForm.latestDeliveryDay = "14"
        this.ruleForm.deliveryTime = ["1","2","3","4","5","6","7"]
      } else {
        this.disabled = false;
        this.ruleForm.latestConfirmDay = null
        this.ruleForm.latestDeliveryDay = null
        this.ruleForm.deliveryTime = []
        this.ruleForm.wholesaleType = null;
       }
    },
    onChangeBusinessRegion(val) {
      if (val != 5) {
        this.ruleForm.boutiqueAssistantTwoId = null;
        this.ruleForm.boutiqueAssistantTwo = null;
      }
    },
    getCountryRegex(code) {
      if ("PK" === code) {
        return /^[0-9]{5}$/;
      } else if ("CN" === code) {
        return /^[0-9]{6}$/;
      } else if ("HK" === code) {
        return null;
      } else if ("MO" === code) {
        return null;
      } else if ("AT" === code) {
        return /^[0-9]{4}$/;
      } else if ("BE" === code) {
        return /^[0-9]{4}$/;
      } else if ("BG" === code) {
        return /^[0-9]{4}$/;
      } else if ("HR" === code) {
        return /^[0-9]{5}$/;
      } else if ("CY" === code) {
        return /^[0-9]{4}$/;
      } else if ("CZ" === code) {
        return /^[0-9]{5}$/;
      } else if ("DK" === code) {
        return /^[0-9]{4}$/;
      } else if ("EE" === code) {
        return /^[0-9]{5}$/;
      } else if ("FI" === code) {
        return /^[0-9]{5}$/;
      } else if ("FR" === code) {
        return /^[0-9]{5}$/;
      } else if ("DE" === code) {
        return /^[0-9]{5}$/;
      } else if ("GR" === code) {
        return /^[0-9]{5}$/;
      } else if ("HU" === code) {
        return /^[0-9]{4}$/;
      } else if ("IE" === code) {
        return null;
      } else if ("IT" === code) {
        return /^[0-9]{5}$/;
      } else if ("LV" === code) {
        return /^[0-9]{4}$/;
      } else if ("LT" === code) {
        return /^[0-9]{5}$/;
      } else if ("LU" === code) {
        return /^[0-9]{4}$/;
      } else if ("MT" === code) {
        return null;
      } else if ("NL" === code) {
        return /^[0-9]{4}$/;
      } else if ("PL" === code) {
        return /^[0-9]{5}$/;
      } else if ("PT" === code) {
        return /^[0-9]{7}$/;
      } else if ("RO" === code) {
        return /^[0-9]{6}$/;
      } else if ("SK" === code) {
        return /^[0-9]{5}$/;
      } else if ("SI" === code) {
        return /^[0-9]{4}$/;
      } else if ("ES" === code) {
        return /^[0-9]{5}$/;
      } else if ("SE" === code) {
        return /^[0-9]{5}$/;
      } else if ("GB" === code) {
        return /^[0-9a-zA-Z]+$/;
      } else if ("US" === code) {
        return /^[0-9]{5}$/;
      } else if ("RU" === code) {
        return /^[0-9]{6}$/;
      } else if ("CA" === code) {
        return /^[0-9a-zA-Z]+$/;
      } else if ("AU" === code) {
        return /^[0-9]{3,4}$/;
      } else if ("NZ" === code) {
        return /^[0-9]{4}$/;
      } else if ("TW" === code) {
        return /^[0-9]{3,5}$/;
      } else if ("PH" === code) {
        return /^[0-9]{4}$/;
      } else if ("KR" === code) {
        return /^[0-9]{5}$/;
      } else if ("MY" === code) {
        return /^[0-9]{5}$/;
      } else if ("JP" === code) {
        return /^[0-9]{7}$/;
      } else if ("TH" === code) {
        return /^[0-9]{5}$/;
      } else if ("SG" === code) {
        return /^[0-9]{6}$/;
      }
      return null;
    },
    onChangeCopyVendor(val) {
      getVendorConfigInfo(val).then(res => {
        if (res.data && res.data.data) {

          const invoiceDto = res.data.data.invoiceReqVo || {};
          if (this.ruleForm.addressCountryId) {
            invoiceDto.addressCountryId = this.ruleForm.addressCountryId;
          }
          this.invoiceDto = invoiceDto;
          this.invoiceDto.registeredPerson = this.invoiceDto.contactPerson || '';
          this.countryList.some(c => {
            if (c.addressCountryId === this.invoiceDto.addressCountryId) {
              this.invoiceDto.areaCode = c.areaCode;
              return true;
            }
            return false;
          })
          this.vendorPayment = res.data.data.paymentInfoReqVo || {};
          this.receivePaymentReqVos = res.data.data.receivePaymentReqVos || [];
        }
      });
    },
    onChangeWholesaleType(val) {
      if (val == 1) {
        this.ruleForm.isPreSale = 2
        this.isPreSaleDisabled = false
      } else if (val == 4 || val == 5) {
        this.ruleForm.isPreSale = 1
        this.isPreSaleDisabled = true
      } else {
        this.ruleForm.isPreSale = null
      }
    }
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  position: relative;
  padding: 20px 20px 100px 20px;

  .footer-bar {
    position: fixed;
    right: 20px;
    bottom: 0;
    left: 210px;
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 20px;
    transition: left 0.3s;
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px 0 0;
    z-index: 10;
  }
}
.form-btn {
  margin-top: 40px;
}
.f12 {
  font-size: 12px;
}
.f14 {
  font-size: 14px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mt30 {
  margin-top: 30px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
.mb30 {
  margin-bottom: 30px;
}
.mb40 {
  margin-bottom: 40px;
}
.pl20 {
  padding-left: 20px;
}
.tr {
  text-align: right;
}
.border-right {
  border-right: 2px solid #DCDFE6;
}
.stock-location {
  max-width: 1000px;
}
.title {
  flex: 1;
  display: flex;
  .id {
    min-width: 100px;
  }
  .name {
    min-width: 200px;
  }
  .status {
    flex: 1;
  }
  .right {
    margin-right: 20px;
  }
}
.area-mobile {
  position: relative;
  padding-left: 65px;

  .area-code {
    position: absolute;
    top: 1px;
    left: 0;
    width: 65px;
  }
}
.email-item {
  position: relative;
  display: inline-block;
  padding: 0 30px 0 10px;
  margin: 0 15px 15px 0;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 30px;

  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;

    &:hover {
      color: #409EFF;
    }
  }
}
.level-list {
  margin-bottom: 20px;
}
.push-email-group {
  display: flex;
  flex-wrap: wrap;
}
.push-email-item {
  display: flex;
  padding: 0 8px 0 2px;
  margin-right: 10px;
  margin-bottom: 5px;
  align-items: center;
  background-color: #f2f2f2;
  border-radius: 40px;

  .el-icon-close {
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
  }
}
.group-title {
  padding-left: 30px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>
<style lang="less">
.searchForm {
  .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
